import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private screenWidthSubject = new BehaviorSubject<number>(window.innerWidth);
  screenWidth$ = this.screenWidthSubject.asObservable();

  constructor() {
    this.updateScreenWidth();
    window.addEventListener('resize', () => this.updateScreenWidth());
  }

  private updateScreenWidth(): void {
    this.screenWidthSubject.next(window.innerWidth);
  }
}
